import React, { useEffect, useRef, useState, ChangeEventHandler } from 'react';

import { IconType } from 'react-icons';
import { useBoolean } from 'usehooks-ts';

import Text from './Text';

interface CriteriaInputProps extends React.HTMLAttributes<HTMLInputElement> {
  endUnit?: string;
  displayLabel: string;
  startIcon?: IconType;
  type?: string;
  placeholdler?: string;
  iconSize?: number;
  className?: string;
  value?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

const CriteriaInput = ({
  endUnit,
  type = 'text',
  onChange,
  placeholder = 'Écrire ici',
  displayLabel,
  className,
  value,
  ...props
}: CriteriaInputProps) => {
  const { value: hasValue, setValue: setHasValue } = useBoolean(!!value);
  const { value: hasFocus, setValue: setHasFocus } = useBoolean(!!value);
  const unitRef = useRef<HTMLDivElement>(null);
  const [unitWidth, setUnitWidth] = useState(0);

  useEffect(() => {
    setHasValue(!!value);
  }, [value, setHasValue]);

  useEffect(() => {
    if (unitRef.current) {
      setUnitWidth(unitRef?.current?.offsetWidth || 40);
    }
  }, [unitRef]);
  return (
    <div className="relative w-full">
      <input
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        onChange={onChange}
        {...props}
        type={type}
        value={value}
        autoComplete="nope"
        placeholder={placeholder}
        style={{ paddingRight: `${unitWidth + 20}px` }}
        className={`input input-bordered w-full rounded-md
        focus:outline-none placeholder:text-gray-600 placeholder:font-light placeholder:opacity-0 focus:placeholder:opacity-100
        placeholder:transition-opacity placeholder:text-3xs text-primary text-base  pt-3.5
        border-gray-400 bg-white pl-4 font-bold ${className} ${
          hasValue && '!bg-gray-50'
        }`}
      />
      {/* Layer on top of the select */}
      <div className="absolute inset-0 flex gap-2 pl-[1.1rem] pointer-events-none items-center justify-between w-full">
        {/* Label */}
        <span>
          <Text
            as="p"
            text={displayLabel}
            className={`text-gray-600 transition-all ${
              hasValue || hasFocus
                ? 'transfrom -translate-y-3 text-3xs xl:text-2xs font-light'
                : 'text-xs md:text-sm'
            }`}
          ></Text>
        </span>
        {endUnit && (
          <div
            className="px-3 py-2 bg-gray-200 text-gray-700 mr-3 rounded-md text-2xs font-bold"
            ref={unitRef}
          >
            {endUnit}
          </div>
        )}
      </div>
    </div>
  );
};

export default CriteriaInput;
